import React from 'react';
import { Briefcase, GraduationCap, FileCheck, Sun, Moon } from 'lucide-react';
import logo from '../logo.png';
import logolight from '../logolight.png';
import './Sidebar.css';

const Sidebar = ({ mode, setMode, setScorerResult, theme }) => {
  return (
    <aside className="sidebar">
      <div style={{ marginBottom: '3rem', display: 'flex', justifyContent: 'center' }}>
        <img 
          src={theme === 'dark' ? logo : logolight} 
          alt="EdVentureX Logo" 
          style={{ width: '240px', borderRadius: '12px' }} 
        />
      </div>

      <nav>
        <button
          className={`nav-item-btn ${mode === 'scorer' ? 'active' : ''}`}
          onClick={() => { setMode('scorer'); setScorerResult(null); }}
        >
          <FileCheck size={20} />
          AI Resume Scorer
        </button>

        <button
          className={`nav-item-btn ${mode === 'counsellor' ? 'active' : ''}`}
          onClick={() => { setMode('counsellor'); setScorerResult(null); }}
        >
          <GraduationCap size={20} />
          AI Counsellor
        </button>

        <button 
          onClick={() => { setMode('interviewer'); setScorerResult(null); }} 
          className={`nav-item-btn ${mode === 'interviewer' ? 'active' : ''}`}
        >
          <Briefcase size={20} />
          AI Interviewer
        </button>

        <button 
          onClick={() => { setMode('tutor'); setScorerResult(null); }} 
          className={`nav-item-btn ${mode === 'tutor' ? 'active' : ''}`}
        >
          <GraduationCap size={20} />
          AI Tutor
        </button>
      </nav>

    </aside>
  );
};

export default Sidebar;
